import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CheckButton } from '../Button';
import { Icon } from '../Icon';
import { tableHead, tableHeadCell, tableHeadIcon } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var TableHead = function TableHead(_ref) {
  var columns = _ref.columns,
      getData = _ref.getData,
      tableOptions = _ref.tableOptions,
      hasSelection = _ref.hasSelection,
      selectRow = _ref.selectRow,
      allSelected = _ref.allSelected;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sort = _useState2[0],
      setSort = _useState2[1];

  var changeSort = function changeSort(column) {
    return function () {
      var value = column.value;
      var isDesc = sort === value;
      var newSort = isDesc ? "".concat(value, "Descending") : sort === "".concat(value, "Descending") ? null : value;
      setSort(newSort);
      getData({
        sort: newSort && {
          sortField: value,
          sortOrder: isDesc ? 'desc' : 'asc'
        }
      });
    };
  };

  return ___EmotionJSX("div", {
    css: tableHead
  }, hasSelection && !!tableOptions.current.totalResults && ___EmotionJSX("div", {
    css: tableHeadCell({
      width: 40,
      render: true
    })
  }, ___EmotionJSX(CheckButton, {
    onChange: selectRow,
    value: allSelected
  })), columns.map(function (column) {
    var sortable = column.sortable,
        name = column.name,
        value = column.value;
    return sortable ? ___EmotionJSX("div", {
      key: name,
      css: tableHeadCell(column),
      role: "button",
      tabIndex: "-1",
      onClick: changeSort(column)
    }, name, ___EmotionJSX(Icon, {
      iconName: "arrow_downward",
      css: tableHeadIcon(sort === value, sort === "".concat(value, "Descending"))
    })) : ___EmotionJSX("div", {
      key: name,
      css: tableHeadCell(column)
    }, name);
  }));
};

TableHead.propTypes = {
  columns: PropTypes.array,
  getData: PropTypes.func,
  hasSelection: PropTypes.bool,
  selectRow: PropTypes.func,
  allSelected: PropTypes.bool,
  tableOptions: PropTypes.object
};
export default TableHead;